<!-- Modal -->
<div class="readmore-modal">
  <div class="modal-card">
    <!-- Header -->
    <div class="modal-header">
      <div class="tabs">
        <button
          *ngIf="marqueeRows?.length"
          class="tab"
          [class.active]="activeTab === 'general'"
          (click)="activeTab = 'general'">
          {{ 'General' | translate }}
        </button>
        <button
          class="tab"
          [class.active]="activeTab === 'maintenance'"
          (click)="activeTab = 'maintenance'">
          {{ 'Maintenance' | translate }}
        </button>
      </div>

      <button
        title="Close (Esc)"
        type="button"
        class="close-btn"
        (click)="onCloseDialog()">
        ×
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <!-- GENERAL -->
      <section *ngIf="activeTab === 'general'">
        <ng-container *ngIf="marqueeRows?.length; else noGeneral">
          <div class="stack">
            <div class="card" *ngFor="let row of marqueeRows; trackBy: trackByIdx">
              <p class="content">
                <ng-container *ngIf="row?.contents?.length; else fallbackContent">
                  {{ row.contents[0]?.content }}
                </ng-container>
                <ng-template #fallbackContent>
                  {{ row?.content || '' }}
                </ng-template>
              </p>

              <div class="date">
                {{
                  (row?.contents?.length ? row.contents[0]?.created_at : row?.created_at)
                    | date:'dd/MM/yyyy'
                }}
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #noGeneral>
          <div class="empty">{{ 'No announcements right now. Please check back later.' | translate }}</div>
        </ng-template>
      </section>

      <!-- MAINTENANCE -->
      <section *ngIf="activeTab === 'maintenance'">
        <ng-container *ngIf="maintenanceRows?.length; else emptyMaint">
          <div class="stack">
            <div class="card maint" *ngFor="let item of maintenanceRows; trackBy: trackByIdx">
              <div class="maint-title">
                <span class="name">{{ item.provider_name }}</span>
                <span class="badge" *ngIf="item.is_ongoing">{{ 'Ongoing' | translate }}</span>
              </div>

              <div class="maint-sub">
                <span class="when">{{ item.display_time }}</span>
                <span class="cat" *ngIf="item.category_name">• {{ item.category_name }}</span>
              </div>
            </div>
            <div class="alert-soft">
              {{ emptyMessage }}
            </div>
          </div>
        </ng-container>

        <ng-template #emptyMaint>
          <div class="alert-soft">
            {{ 'All games are working normally again.' | translate }}
          </div>
        </ng-template>
      </section>
    </div>
  </div>
</div>
  <!--End modal-->
  